<template>
  <div>
    <lcontainer class="mb-4">
      <div class="heading  py-4 px-8">
        <div class="page text-white">{{ getTenantCourse.title }}</div>
      </div>
    </lcontainer>

    <lcontainer>
      <div class="py-4 px-8">
        <div class="flex justify-between">
          <page-header class="py-2 tenant-main-color"
            >Course Information</page-header
          >
        </div>
        <div v-if="getTenantCourse" class="flex flex-wrap">
          <div class="w-full md:w-1/2 items-center form-row  px-4">
            <div class="flex flex-row justify-between my-4">
              <div class=" font-semibold">Course Description:</div>
              <div>
                <p>{{ getTenantCourse.normal_course_description }}</p>
              </div>
            </div>
            <div class="flex flex-row justify-between my-4">
              <div class=" font-semibold">Course Duration:</div>
              <div>
                <p>{{ getTenantCourse.duration }}</p>
              </div>
            </div>
            <div
              v-if="getTenantCourse.course_instructor"
              class="flex flex-row justify-between my-4"
            >
              <div class=" font-semibold">Course Instructor:</div>
              <div>
                <p>
                  {{ getTenantCourse.course_instructor.first_name }}
                  {{ getTenantCourse.course_instructor.last_name }}
                </p>
              </div>
            </div>
            <div class="flex flex-row justify-between my-4">
              <div class=" font-semibold">Payment Type:</div>
              <div>
                <p>{{ getTenantCourse.payment_type }}</p>
              </div>
            </div>
          </div>
          <div class="w-full md:w-1/2 flex justify-end">
            <div>
              <lms-button
                class="block mb-2"
                @click="
                  $router.push({
                    name: 'tenant-course-modules-home',
                    params: { id: $route.params.id },
                  })
                "
                >Manage Modules</lms-button
              >
              <lms-button
                class="block mb-2"
                @click="$Bus.$emit('create-lesson')"
                >Add Lesson</lms-button
              >
            </div>
          </div>
        </div>
      </div>
    </lcontainer>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  components: {
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
    PageHeader: () => import("@/components/general/pageheader"),
    LmsSelect: () => import("@/components/forms/select"),
  },
  data() {
    return {
      form: {},
    };
  },

  computed: {
    ...mapGetters(["getTenantCourse"]),
  },

  created() {
    this.updateLoader(true);
    this.fetchSingleTenantCourse({
      id: this.$route.params.id,
    });
    this.updateLoader(false);
  },
  methods: {
    ...mapActions(["fetchSingleTenantCourse"]),
    navigate() {
      this.$router.push(`/tenants/courses/${this.$route.params.id}/modules`);
    },
  },
};
</script>
<style lang="scss" scoped>
.form-row {
  .modal-title {
    font-size: 24px;
    color: color(lms-admin);
  }

  .modal-field {
    color: color(lms-admin);
    margin-right: 4rem;
  }
  .close {
    background-color: #c2454b;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    font-size: 12px;
    top: -17px;
    z-index: 2;
    right: 11px;
  }
  z-index: 1;
  // max-width: 500px;
}
</style>
